import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';
import { ProjectName, ProjectSlogan2 } from '../../variables/DigmaDef'
import HeaderLinks from '../Header/HeaderLinks.jsx';

import imagine from 'assets/img/sidebar-3.jpg';
import logo from 'assets/img/digmalogo.png';

import appRoutes from 'routes/app.jsx';

class Sidebar extends Component{
    constructor(props){
        super(props);
        this.state = {
            width: window.innerWidth
        }
    }
    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
    }
    updateDimensions(){
        this.setState({width:window.innerWidth});
    }
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
    render(){
        const sidebarBackground = {
            backgroundImage: 'url(' + imagine + ')'
        }
        const {mbouser} = this.props
        //console.log("Sidebar this props", this.props)
        /* Romoved logo 
         <a href="https://digma.org.il" className="simple-text logo-mini">
                            <div className="logo-img">
                                <img src={logo} alt="Digma logo"/>
                            </div>

                        </a>

                        =============
            <a href="https://digma.org.il" className="simple-text logo-normal">

        */
        return (
            <div id="sidebar" className="sidebar" data-color="purple" data-image={imagine}>
                <div className="sidebar-background" style={sidebarBackground}></div>
                    <div style={{fontSize:'20px',position:'relative',zIndex:'4', textAlign:'center'}}>
                       <span style={{fontWeight:'400',fontSize:'larger',letterSpacing: '0.2em'}}>{ProjectName}</span><br />
                         <span>{/*ניהול משפחות*/ ProjectSlogan2}</span>
                    </div>
                <div className="sidebar-wrapper">
                    <ul className="nav">
                        { this.state.width <= 991 ? (<HeaderLinks mbouser={mbouser} />):null }
                        {
                            appRoutes.map((prop,key) => {
                                if (prop.path.includes('FamilyReferral') && mbouser.user_role[0] !== "administrator")
                                    return null

                                if(!prop.redirect && !prop.nosidebar)
                                    return (
                                        <li className={prop.upgrade ? "active active-pro":this.activeRoute(prop.path)} key={key}>
                                            <NavLink to={prop.path} className="nav-link" activeClassName="active">
                                                <i className={prop.icon}></i>
                                                <p>{prop.name}</p>
                                            </NavLink>
                                        </li>
                                    );
                                return null;
                            })
                        }
                    </ul>
                    <a target="_blank" rel="noopener noreferrer" href="https://digma.org.il" className="simple-text logo-mini">
                    <div className="logo-img">
                        <img src={logo} alt="Digma logo"/>
                    </div>
                </a>
                </div>
                
            </div>
        );
    }
}

export default Sidebar;
